import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8837dd7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8837dd7a&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=8837dd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8837dd7a",
  null
  
)

export default component.exports